import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from './api/session';
import { App } from './App';
import './theme.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // A recruiter switching between list and report expects the list to be current, not a
            // minute-old snapshot of interviews that have since been reviewed.
            staleTime: 10_000,
            retry: false,
            refetchOnWindowFocus: false
        }
    }
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <SessionProvider>
                    <App />
                </SessionProvider>
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>
);
